import { env } from '@/config/env'

export type AnalyticsEnvironment = 'local' | 'dev' | 'qa' | 'staging' | 'prod'

/** Deployment tag sent as PostHog super-property on every capture (BFP-492). */
export function resolveAnalyticsEnvironment(): AnalyticsEnvironment {
  return env.VITE_APP_ENV
}
